<mf-page title="Editar usuario">
  @if (appUserCreateDto) {
  <mf-app-user
    [appUserCreateDto]="appUserCreateDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
